import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { GridModule } from '@progress/kendo-angular-grid';
import { GetJsonService } from '../../services/get-json.service';

@Component({
  selector: 'app-project-tank-battery-details',
  templateUrl: './project-tank-battery-details.component.html',
  styleUrls: ['./project-tank-battery-details.component.scss'],
  imports: [
    MatCardModule,
    GridModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    GetJsonService,
  ],
})
export class ProjectTankBatteryDetailsComponent implements OnInit {
  private getJsonService = inject(GetJsonService);

  private tTankBattery1: string = 'assets/data/tank-battery1.json';
  private tTankBattery2: string = 'assets/data/tank-battery2.json';

  public dGrid1: any[] = [];
  public dGrid2: any[] = [];

  public errorMessage: string;

  readonly xProjectId = input<number>(undefined);

  ngOnInit() {
    this.getJsonService.get(this.tTankBattery1)
      .subscribe(
        payload => {
          this.dGrid1 = payload;
          //  error => this.errorMessage = <any>error;
        });

    this.getJsonService.get(this.tTankBattery2)
      .subscribe(
        payload => {
          this.dGrid2 = payload;
          // error => this.errorMessage = <any>error;
        });
  }
}